<template>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "schema"],


        methods: {

            init: function () {

                this.model.guests = false;
                this.model.guests_data = [];
                this.model.guests_data.push({
                    // guests
                    first_name: "",
                    last_name: "",
                    email: "",
                    reminders: false,
                });

                this.schema.groups.push({
                        fields: [{
                            type: "customCheckbox",
                            label: "Želite prijaviti dodatno osebo?",
                            model: "guests",
                            listBox: true,
                            text: "Da, želim prijaviti dodatno osebo",
                            styleClasses: "col-sm-12",
                            onChanged(model) {
                                if(model.guests === true) {
                                    model.quantity = 2;
                                } else {
                                    model.quantity = 1;
                                }
                                Event.$emit("prijavnica_update_totals", "");
                            }
                        },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Ime",
                                model: "guests_data.0.first_name",
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-6',
                                visible(model) {
                                    return model.guests
                                },
                                required: true
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Priimek",
                                model: "guests_data.0.last_name",
                                validator: VueFormGenerator.validators.string,
                                styleClasses: 'col-sm-6',
                                visible(model) {
                                    return model.guests
                                },
                                required: true
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: "Email",
                                model: "guests_data.0.email",
                                validator: VueFormGenerator.validators.email,
                                styleClasses: 'col-sm-12',
                                visible(model) {
                                    return model.guests;
                                },
                                required: true
                            },
                            {
                                type: "customCheckbox",
                                label: "",
                                model: "guests_data.0.reminders",
                                text: "Želite, da pošljemo email z informacijami tej osebi?",
                                styleClasses: "col-sm-12",
                                visible(model) {
                                    return model.guests;
                                },
                            }
                        ]
                    }
                );
            }
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/Guests.vue